export const MatchTab = {
  MATCHES: 'matches',
  SEARCH_PROFILES: 'searchProfiles',
};
